import React from 'react'
import { Routes as Switch, Route, Navigate } from 'react-router-dom'

import PrivateRoute from './components/PrivateRoute'
import Layout from './components/Layout'

import Products from './page/Products'
import MyWishlists from './page/MyWishlists'
import Lojinha from './page/Lojinha'
import UserWishList from './page/UserWishList'
import EditWishList from './page/EditWishList'
import WishList from './page/CreateWishList';
import DevLogin from './page/DevLogin/DevLogin';

import useWishList from './hooks/WishListContext'

const Routes: React.FC = () => {

    const { wishListIsOpen } = useWishList()

    return (
        <Switch>
            <Route path="/lojinha/:linkId" element={<Lojinha />} />
            <Route path="/:linkName/:code/:linkId" element={<Lojinha />} />
            <Route path="/admin/login" element={<PrivateRoute shouldBeAuth={false} element={<DevLogin />} />} />

            <Route element={<Layout deleteNav={wishListIsOpen} />}>
                <Route path="/products" element={<PrivateRoute shouldBeAuth element={<Products />} />} />
                <Route path="/my-wishlists/:environment/:linkId" element={<PrivateRoute shouldBeAuth element={<UserWishList />} />} />
                <Route path="/my-wishlists/:environment/:linkName/:code/:linkId" element={<PrivateRoute shouldBeAuth element={<UserWishList />} />} />
                <Route path="/my-wishlists" element={<PrivateRoute shouldBeAuth element={<MyWishlists />} />} />
            </Route>

            <Route element={<Layout deleteNav />}>
                <Route path="/create-wishlist" element={<PrivateRoute shouldBeAuth element={<WishList />} />} />
                <Route path="/edit-wishlist/:linkId" element={<PrivateRoute shouldBeAuth element={<EditWishList />} />} />
            </Route>

            <Route path="*" element={<Navigate replace to="/products" />} />
        </Switch>
    )
}

export default Routes